const STORAGE_KEY = "teacherPayrollPayments";

const safeParse = (value) => {
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
};

export const getPayrollPayments = () => {
  if (typeof window === "undefined") return [];
  const raw = localStorage.getItem(STORAGE_KEY);
  if (!raw) return [];
  return safeParse(raw);
};

export const savePayrollPayments = (payments) => {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(payments));
};

export const recordPayrollPayment = (paymentRecord) => {
  const nextRecord = {
    id: paymentRecord.id || `pay-${Date.now()}`,
    teacherId: paymentRecord.teacherId || "",
    teacherName: paymentRecord.teacherName || "",
    teacherEmail: String(paymentRecord.teacherEmail || "").toLowerCase(),
    amount: Number(paymentRecord.amount || 0),
    paidOn: paymentRecord.paidOn || new Date().toISOString().slice(0, 10),
    method: paymentRecord.method || "BANK_TRANSFER",
    referenceId: paymentRecord.referenceId || "",
    accountHolderName: paymentRecord.accountHolderName || paymentRecord.teacherName || "",
    bankName: paymentRecord.bankName || "",
    accountNumber: paymentRecord.accountNumber || "",
    ifscCode: paymentRecord.ifscCode || "",
    upiId: paymentRecord.upiId || "",
    notes: paymentRecord.notes || "",
    processedBy: paymentRecord.processedBy || "Admin",
    createdAt: paymentRecord.createdAt || new Date().toISOString(),
  };

  const current = getPayrollPayments();
  const next = [nextRecord, ...current];
  savePayrollPayments(next);
  return nextRecord;
};

export const getTeacherPayrollPayments = (teacherIdentity = {}) => {
  const payments = getPayrollPayments();
  const email = String(teacherIdentity.teacherEmail || "").toLowerCase();
  const id = String(teacherIdentity.teacherId || "").trim();
  const name = String(teacherIdentity.teacherName || "").trim().toLowerCase();

  return payments.filter((entry) => {
    if (email && String(entry.teacherEmail || "").toLowerCase() === email) return true;
    if (id && String(entry.teacherId || "") === id) return true;
    if (name && String(entry.teacherName || "").trim().toLowerCase() === name) return true;
    return false;
  });
};
